
import MdContent from 'components/md-content-v2'
import Jobs from './jobs'
import Education from './education'
import AiTabs from 'components/ai-chat-v2/ai-tabs.vue'
export default {
  components: {MdContent, AiTabs, Jobs, Education},
  props: {
    data: {type: Object, required: true},
  },
  data(){
    return {
      active_tab: undefined
    }
  },
  computed: {
    title(){
      return this.data.title
    },
    jobs(){
      return this.data.jobs?.length ? this.data.jobs : undefined
    },
    education(){
      return this.data.education?.length ? this.data.education : undefined
    },
    summary(){
      return this.data.summary
    },
    loading(){
      if (this.jobs || this.education) return false
      return true
    },
    tabs(){
      const tabs = []
      if (this.summary) tabs.push({title: 'Summary', value: 'summary'})
      if (this.jobs) tabs.push({title: 'Career', value: 'jobs'})
      if (this.education) tabs.push({title: 'Education', value: 'education'})
      return tabs
    },
  },
  watch: {
    loading(){
      this.setTab()
    }
  },
  mounted(){
    if (!this.loading) this.setTab()
  },
  methods: {
    setTab() {
      if (this.summary) this.active_tab = 'summary'
      else if (this.jobs) this.active_tab = 'jobs'
      else this.active_tab = 'education'
    }
  }
}
